import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { setTokenUser } from "../../configuration";
import UserController from "../../controllers/UserController";
import { setAuthenticated } from "../../store/actions/auth";
import { getAllPermissions } from "../../store/actions/permissions";
import CRM from "../CRM/CRM";
import Login from "./Login";

const initialState = {
    user: null,
}

const userController = new UserController();

class App extends Component
{
    state = {...initialState, hasUserLogged: false}
    
    componentDidMount = () =>
    {
        this.hasUserSession();
    }

    componentDidUpdate = async (prevProps) =>
    {
        // console.log("APP prevProps ", prevProps);
        // console.log("APP this.props ", this.props);

        if (this.state.hasUserLogged !== this.props.hasUserLogged)
        {
            
            if (!this.props.hasUserLogged) 
            {
               this.onLogout();
            }
            
        }
    }

    hasUserSession = async () =>
    {

        let userLocalStorage = sessionStorage.getItem("USER_CRM_SEMPNET");
        const user = this.props.user;

        if (user === null) 
        {
            if (userLocalStorage !== null)
            {
                userLocalStorage = JSON.parse(userLocalStorage);
                this.props.setAuthenticated(userLocalStorage);
                setTokenUser(userLocalStorage.token);
                this.setState({ hasUserLogged: true, user: userLocalStorage});

                const getUpdatedUser = await userController.getById(userLocalStorage.PER_ID);

                if (getUpdatedUser.status)
                {
                    const updatedUser = {
                        ...getUpdatedUser.data,
                        token: userLocalStorage.token
                    };

                    sessionStorage.setItem("USER_CRM_SEMPNET", JSON.stringify(updatedUser));

                    if (getUpdatedUser.data.PER_STATUS === 2)
                    {
                        return this.setState({ hasUserLogged: false });
                    }

                    this.props.setAuthenticated(updatedUser);
                    this.setState({
                        user: updatedUser
                    });
                    
                    this.props.getAllPermissions();
                }
            }
            else
            {
                this.setState({ hasUserLogged: false });
            }
        }
        else
        {
            this.setState({ hasUserLogged: true, user });
            this.props.getAllPermissions();
        }

    }

    onLogin = () =>
    {
        sessionStorage.setItem("USER_CRM_SEMPNET", JSON.stringify(this.props.user));
        this.setState({ hasUserLogged: true, user: this.props.user });
        this.props.getAllPermissions();
    }
    
    onLogout = async () => 
    {
        sessionStorage.removeItem("USER_CRM_SEMPNET");
        await this.props.setAuthenticated({});
        this.setState({hasUserLogged: false});
        window.location.href = "/";
    }
    
    render ()
    {
        return (
            <Fragment>
                {
                    this.state.hasUserLogged
                    ? <CRM onLogout={this.onLogout}/>
                    : <Login onLogin={this.onLogin}/>
                }
            </Fragment>
        );
    }

}

function mapStateToProps (state) 
{
    const { user, hasUserLogged } = state.auth

    return {
        user,
        hasUserLogged
    };
}

function mapDispatchToProps (dispatch)
{
    return {
        getAllPermissions()
        {
            const action = getAllPermissions();
            dispatch(action);
        },
        setAuthenticated(data)
        {
            const action = setAuthenticated(data);
            dispatch(action);
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);